import * as React from "react";
import { IsMobileDevice } from "source/app/domain/Device/Helpers/IsMobile";
import { IToolProps } from "./ToolProps";
import { ToolItemWithBorder } from "./ToolItemWithBorder";
import IsNotEqual from "source/app/services/Shared/ReactHelpers";

class Tool extends React.Component<IToolProps> {
    shouldComponentUpdate(nextProps: IToolProps) {
        try {
            return IsNotEqual(this.props, nextProps);
        } catch (e) {
            throw new Error(`
                Unable to check if component
                with the classes ${nextProps.options.classes}
                should be updated`);
        }
    }

    DoNothing = () => {};

    render() {
        let { options, children } = this.props;
        const linkContent = (
            <span
                className={
                    "inlineLink glyphicon " +
                    (options.classes || "")
                }
            >
                <span className="inlineLinkContent">{children}</span>
            </span>
        );
        const actionButtonStyle = {
            appearance: `none`,
            border: 0,
            margin: 0,
            padding: 0,
            background: `transparent`,
            color: `inherit`,
            font: `inherit`,
            cursor: `pointer`,
            touchAction: `manipulation`,
        } as React.CSSProperties;

        return options.ForAllDevices || !IsMobileDevice() ? (
            <ToolItemWithBorder $shouldShow={true}>
                <span style={options.style || {}} data-tip={options.tooltip}>
                    {options.link ? (
                        <a
                            href={options.link}
                            target={options.target || "_self"}
                            onClick={options.onClick || this.DoNothing}
                            onMouseEnter={options.onMouseEnter || this.DoNothing}
                            onMouseLeave={options.onMouseLeave || this.DoNothing}
                        >
                            {linkContent}
                        </a>
                    ) : (
                        <button
                            type="button"
                            style={actionButtonStyle}
                            onClick={options.onClick || this.DoNothing}
                            onMouseEnter={options.onMouseEnter || this.DoNothing}
                            onMouseLeave={options.onMouseLeave || this.DoNothing}
                        >
                            {linkContent}
                        </button>
                    )}
                </span>
            </ToolItemWithBorder>
        ) : null;
    }
}

export default Tool;
